import React, { useState, useEffect } from 'react';
import {apiUrl}from '../utils/Constants.js'
import axios from 'axios';
import Cookies from "js-cookie";
export const API= {
    token: function(){
        let jwt = Cookies.get('jwt');
        if(jwt) {
            return jwt;
        }
        else{
            return null;
        }

    },
    //@TODO: FONTOS! a proxy miatt habár singlepage application az oldal, az url-nek matchelnie kell az api végpontot
    async post(entity, custom_params = null) {

        // Egyedi paraméterek kezelése
        const params = custom_params || entity.params || {};

        try {
            // Az axios.post kérést próbáljuk végrehajtani
            const response = await axios.post(entity.url, params, entity.config);
            // Siker esetén visszaadjuk a válasz adatokat
            return response.data;
        } catch (error) {
            // Axios hibakezelés, a hívó oldalon kezelhető hibát dobunk
            return {
                statusz: 0,
                statusCode: error.status,
                message: error.response?.data?.message || error.message || 'Ismeretlen hiba történt'
            }
        }
    },
    async put(entity, custom_params = null) {
        // Egyedi paraméterek kezelése
        const params = custom_params || entity.params || {};

        try {
            // Az axios.post kérést próbáljuk végrehajtani
            const response = await axios.put(entity.url, params, entity.config);

            // Siker esetén visszaadjuk a válasz adatokat
            return response.data;
        } catch (error) {
            // Axios hibakezelés, a hívó oldalon kezelhető hibát dobunk
            return {
                statusz: 0,
                statusCode: error.status,
                message: error.response?.data?.message || error.message || 'Ismeretlen hiba történt'
            }
        }
    },
    async patch(entity, custom_params = null) {

        // Egyedi paraméterek kezelése
        const params = custom_params || entity.params || {};

        try {
            // Az axios.post kérést próbáljuk végrehajtani
            const response = await axios.patch(entity.url, params, entity.config);

            // Siker esetén visszaadjuk a válasz adatokat
            return response.data;
        } catch (error) {
            // Axios hibakezelés, a hívó oldalon kezelhető hibát dobunk
            return {
                statusz: 0,
                statusCode: error.status,
                message: error.response?.data?.message || error.message || 'Ismeretlen hiba történt'
            }
        }
    },
    async delete(entity) {

        // Egyedi paraméterek kezelése

        try {
            // Az axios.post kérést próbáljuk végrehajtani
            const response = await axios.delete(entity.url, entity.config);

            // Siker esetén visszaadjuk a válasz adatokat
            return response.data;
        } catch (error) {
            // Axios hibakezelés, a hívó oldalon kezelhető hibát dobunk
            return {
                statusz: 0,
                statusCode: error.status,
                message: error.response?.data?.message || error.message || 'Ismeretlen hiba történt'
            }
        }
    },
    //@TODO: FONTOS! a proxy miatt habár singlepage application az oldal, az url-nek matchelnie kell az api végpontot
    async get(entity,custom_params=null){
        const params = custom_params || entity.params || {};
        try {
            // Az axios.get kérést próbáljuk végrehajtani
            const response = await axios.get(entity.url,{...entity.config,params:params});

            // Siker esetén visszaadjuk a válasz adatokat
            return response.data;
        } catch (error) {
            // Axios hibakezelés, a hívó oldalon kezelhető hibát dobunk
            return {
                statusz: 0,
                statusCode: error.status,
                message: error.response?.data?.message || error.message || 'Ismeretlen hiba történt'
            }
        }
    },
    //@TODO: FONTOS! a proxy miatt habár singlepage application az oldal, az url-nek matchelnie kell az api végpontot
    async request(entity,custom_params=null){
        if(entity.method === 'GET'){
            return await API.get(entity);
        }
        else if(entity.method === 'POST'){
            return await API.post(entity,custom_params);
        }
    },
    async rest(entity,method,custom_params,id=null){
        let custom_entity={...entity};
        if(method === 'GET'){
            if(id!==null){
                custom_entity.url=custom_entity.url+"/"+id;
                return await API.get(custom_entity,custom_params);
            }
            else return await API.get(custom_entity,custom_params);
        }
        else if(method === 'POST'){
            if(id!==null){
                custom_entity.url=custom_entity.url+"/"+id;
                return await API.post(custom_entity,custom_params);
            }
            else return await API.post(custom_entity,custom_params);
        }
        else if(method === 'PUT'){
            if(id!==null){
                custom_entity.url=custom_entity.url+"/"+id;
                return await API.put(custom_entity,custom_params);
            }
            else return {
                status:0,
                message:'PUT hívás ID nélkül'
            };
        }
        else if(method === 'PATCH'){
            if(id!==null){
                custom_entity.url=custom_entity.url+"/"+id;
                return await API.patch(custom_entity,custom_params);
            }
            else return {
                status:0,
                message:'PATCH hívás ID nélkül'
            };
        }
        else if(method === 'DELETE'){
            if(id!==null){
                custom_entity.url=custom_entity.url+"/"+id;
                return await API.delete(custom_entity);
            }
            else return {
                status:0,
                message:'DELETE hívás ID nélkül'
            };
        }
    }
}

export const Entities={
    presenter:{
        url: apiUrl+ "presenter",
        method: "",
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    exhibitor:{
        url: apiUrl+ "exhibitor",
        method: "",
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    sponsor:{
        url: apiUrl+ "sponsor",
        method: "",
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    press:{
        url: apiUrl+ "press",
        method: "",
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    event:{
    url: apiUrl+ "event",
        method: "",
        get config (){
        return {
            withCredentials: false
        }
    },
    params:{}
    },
    eventfilters:{
        url: apiUrl+ "event/filters",
        method: "",
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    requestTicket:{
        url: apiUrl+ "requestticket",
        method: "",
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    buyTicket:{
        url: apiUrl+ "buy",
        method: "",
        get config (){
            return {
                headers: {
                    Authorization: `Bearer ${API.token()}`,
                },
                withCredentials: false
            }
        },
        params:{}
    },
    confirmPayment:{
        url: apiUrl+ "payment/confirm",
        method:'',
        get config (){
            return {
                headers: {
                    Authorization: `Bearer ${API.token()}`,
                },
                withCredentials: false
            }
        },
        params:{}
    },
    ticket:{
        url: apiUrl+ "ticket",
        method:'',
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },

    checkToken:{
        url: apiUrl+ "checkToken",
        method:'',
        get config (){
            return {
                headers: {
                    Authorization: `Bearer ${API.token()}`,
                },
                withCredentials: false
            }
        },
        params:{}
    },
    coupon:{
        url: apiUrl+ "coupon",
        method:'',
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    email:{
        url: apiUrl+ "email",
        method: '',
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    vatService:{
        url: "https://services.mbsm.hu/checktaxpayer",
        method: '',
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    zipService:{
        url: "https://services.mbsm.hu/zipsearch",
        method: '',
        get config (){
            return {
                withCredentials: false
            }
        },
        params:{}
    },
    login:{
      url: apiUrl+"login",
      method: 'POST',
      config:{
          headers: {
              'Content-Type': 'application/json'
          },
          withCredentials: false
      },
      params:{}
    },
    logout:{
        url: apiUrl+"logout",
        method: 'GET',
        get config (){
            return {
                headers: {
                    Authorization: `Bearer ${API.token()}`,
                },
                withCredentials: false
            }
        },
        params:{}
    },
    confirmation:{
        url: apiUrl+'confirmation',
        method: 'POST',
        params:{}
    },
    test:{
        url: apiUrl+"test",
        method: 'POST',
        get config (){
            return {
                headers: {
                    Authorization: `Bearer ${API.token()}`,
                },
                withCredentials: false
            }
        },
        params:{}
    },
    rest:{
        //@TODO: itt nem működik a relatív url, mert aloldalról indul a hívás, ezért a saját teljes url kell
        user:{
            url: apiUrl+"users",
            get config (){
                return {
                    headers: {
                        Authorization: `Bearer ${API.token()}`,
                    },
                    withCredentials: false
                }
            }
        }
    },
    galleryYears:{
        url: apiUrl+'galeriak',
        method:'GET',
        params:{}
    },
    gallery:{
        url: apiUrl+'galeria',
        method:'GET',
        params:{}
    }
}